export enum IvLinkType {
  None = 'none',
  Auto = 'auto',
  Interactive = 'interactive',
}

export enum IvSyncStatus {
  None = 0,
  Sync = 1,
  noSync = 2,
}
